import { addSavedOffer } from '@cian/favorites-assign-widget';

import { TThunkAction } from '../../types/redux';
import { addToFavorite as addToFavoriteService } from '../../services/favorites';
import { toggleFavorite } from '../../actions/recommendations';
import { trackAddToFavorite } from './tracking';
import { TFavoriteActionParameters } from './types';

export function addToFavorite(parameters: TFavoriteActionParameters): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const { recommendation } = parameters;

    dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: true }));

    let response: Awaited<ReturnType<typeof addToFavoriteService>>;

    try {
      response = await addToFavoriteService(context, {
        dealType: recommendation.dealType,
        offerId: recommendation.offerId,
        offerType: recommendation.offerType,
      });
    } catch (error) {
      dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: false }));

      throw error;
    }

    trackAddToFavorite(parameters);

    const folder = response.folder;
    const savedInFolders =
      folder && folder.name && folder.id
        ? [
            {
              id: folder.id,
              name: folder.name,
            },
          ]
        : null;

    dispatch(
      addSavedOffer({
        offerIds: [recommendation.offerId],
        savedInFolders,
        userHasFolders: Boolean(response.hasFolders),
      }),
    );
  };
}
